const filterMappings = {
  'status.name': (key, value) => `${key} eq '${value[0]}'`,
}

export default filterMappings